import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { HeroSection } from '../components/landing/HeroSection';

export const LandedPage: React.FC = () => {
  return (
    <div className="space-y-24">
      {/* Testimonials Section with Ollie's Photo */}
      <TestimonialsSection />

      {/* Hero Section */}
      <HeroSection />

      {/* Features Grid */}
      <div className="mt-24">
        <FeaturesSection />
      </div>
    </div>
  );
};